import Cookies from 'js-cookie';
import { getUrlPartnerCode } from './giftWithPurchasePromo';
import { hasEntitlementCookie } from './setCouponCookie';
import { PARTNER_COOKIE_NAME, PartnerCookieData } from './util/partnerCookie';

/**
 * Whether this session carries a partner, gift-with-purchase, or rescue offer: a `?pc=` / `?discount=`
 * code on the url, the partner cookie the auto-apply flow sets from one, or a signed gwa/gwp
 * entitlement. Those offers discount a membership bundle, so an enrolled shopper stays on the
 * control PDP where the bundle is for sale instead of the hardware-only arm.
 */
export function inPartnerPromoContext(): boolean {
  if (getUrlPartnerCode()?.trim() || hasEntitlementCookie()) {
    return true;
  }

  try {
    const partnerCookie = Cookies.getJSON(PARTNER_COOKIE_NAME) as PartnerCookieData | undefined;
    return !!partnerCookie?.isPartner;
  } catch {
    return false;
  }
}
